import { func } from 'prop-types';
import React, { PureComponent } from 'react';

import atgLogo from 'calendar/images/atg.png';
import europatipsetLogo from 'calendar/images/europatipset.svg';
import stryktipsetLogo from 'calendar/images/stryktipset.svg';
import topptipsetLogo from 'calendar/images/topptipset.svg';
import { calendarJackpot } from 'calendar/proptypes';
import Button from 'shared/components/button/Button';
import ProductName from 'shared/components/ProductName';
import { formatCalendar } from 'shared/utils/dateUtils';
import { getText, uppperFirst } from 'shared/utils/Text';

export default class JackpotItem extends PureComponent {
  static propTypes = {
    jackpot: calendarJackpot.isRequired,
    onClick: func.isRequired,
  };

  static logoMap = {
    ATG: atgLogo,
    Stryktipset: stryktipsetLogo,
    Europatipset: europatipsetLogo,
    Topptipset: topptipsetLogo,
  };

  onClick = e => {
    e.preventDefault();
    const { jackpot, onClick } = this.props;
    onClick(jackpot);
  };

  render() {
    const {
      jackpot: { product, amount, date, isAtg },
    } = this.props;
    return (
      <li className="jackpot-item">
        <img
          className={isAtg ? 'atg' : 'svenska-spel'}
          alt={isAtg ? 'ATG' : product}
          src={JackpotItem.logoMap[isAtg ? 'ATG' : product]}
        />
        <span>
          <Button onClick={this.onClick}>
            <ProductName product={product} /> – {amount}{' '}
            {getText(
              isAtg
                ? 'calendar-jackpot-atg-suffix'
                : 'calendar-jackpot-sport-suffix',
            )}
          </Button>
          <span className="date">{uppperFirst(formatCalendar(date))}</span>
        </span>
      </li>
    );
  }
}
